import L from "leaflet";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

// adjusts the map to show the european continent
function MapFitOnEuropeanContinent({
  mapRef,
}: {
  mapRef: React.MutableRefObject<L.Map | null>;
}) {
  const map = useMap();

  useEffect(() => {
    if (map) {
      const bounds = L.latLngBounds([
        [38.0, -10.0], // Southwest point (covers southern France/Mediterranean)
        [55.0, 35.0], // Northeast point (covers northern Germany and Ukraine)
      ]);
      map.fitBounds(bounds);
    }
  }, [map]);

  return null;
}

export default MapFitOnEuropeanContinent;
